module.exports = __webpack_public_path__ + "static/media/branding-logo-topbar.d8ca7a4b.png";